import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";

export const generalPopoverStyle = { borderRadius: "50%", width: "15px", height: "15px", minWidth: "15px", minHeight: "15px", padding: 0, fontSize: "9px", lineHeight: 1, fontWeight: 600, fontStyle: "italic", border: "1px solid #9ca3af", color: "#6b7280", backgroundColor: "transparent", cursor: "pointer" }

const PopOver = ({ title, customStyle, className = "" }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const buttonRef = useRef(null);

  useEffect(() => {
    if (isVisible && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setPosition({
        top: rect.top + window.scrollY - 8,
        left: rect.left + window.scrollX + rect.width / 2,
      });
    }
  }, [isVisible]);

  return (
    <div className={`popover-wrapper ${className}`} style={{ display: 'inline-block' }}>
      <button
        ref={buttonRef}
        type="button"
        tabIndex="-1"
        className={`d-inline-flex align-items-center justify-content-center ml-1 popover-trigger`}
        style={customStyle ? { ...generalPopoverStyle, ...customStyle } : generalPopoverStyle}
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
      >
        i
      </button>
      {isVisible && createPortal(
        <div className="popover-tooltip-portal" style={{
          position: 'absolute',
          top: `${position.top}px`,
          left: `${position.left}px`,
          transform: 'translate(-50%, -100%)',
          backgroundColor: '#1f2937',
          color: '#fff',
          padding: '0.625rem 1rem',
          borderRadius: '8px',
          fontSize: '0.8125rem',
          fontWeight: 500,
          minWidth: '180px',
          maxWidth: '350px',
          whiteSpace: 'normal',
          textAlign: 'center',
          zIndex: 100000000,
          pointerEvents: 'none',
        }}>
          {title}
          <div style={{
            position: 'absolute',
            top: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            borderWidth: '6px',
            borderStyle: 'solid',
            borderColor: '#1f2937 transparent transparent transparent',
          }} />
        </div>,
        document.body
      )}
    </div>
  );
};

export default PopOver;
